module.exports = __webpack_public_path__ + "img/cards_full_no_paypal.0915a504.png";